import { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLspOnboarding } from "./lspSlice";
import {
  fetchCities,
  fetchStates,
  editAddress,
  fetchAddress,
} from "../../../components/entities/address/addressesSlice";
import useLspUpdating from "../actions/useLspUpdating";

function validNumber(x) {
  const out = /^(?!\s*$)[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/.test(x || "");
  return out;
}

const useLspAddressUpdate = () => {
  const dispatch = useDispatch();
  // const location = useLocation();
  const { initialLoads } = useLspUpdating();
  // const activeTab = location.pathname.split("/")[3] || "addresses";
  const [tradeaddress, setAddress] = useState({});
  const [isSaveBtn, setIsSaveBtn] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [successmsg, setSuccessMsg] = useState(false);
  const [isAuditSidebarVisible, setAuditSidebarVisible] = useState(false);

  const { isEdit, lspdetails, statesarray, cityarray, currentaddress } =
    useSelector((state) => state.lsponboarding);
  const isloading = useSelector((state) => state.addresses?.isloading);

  useEffect(() => {
    dispatch(
      setLspOnboarding({
        key: "isEdit",
        value: false,
      }),
    );
  }, []);

  function compareObjects(obj1, obj2) {
    for (const key in obj1) {
      if (Object.prototype.hasOwnProperty.call(obj1, key)) {
        if (typeof obj1[key] === "object" && obj1[key] !== null) {
          if (!compareObjects(obj1[key], obj2[key])) {
            return false;
          }
        } else {
          if (obj1[key] !== obj2[key]) {
            return false;
          }
        }
      }
    }
    return true;
  }

  useEffect(() => {
    const obj = initialdata();
    const isIdentical = compareObjects(obj, tradeaddress);

    const isTradeAddressValid =
      tradeaddress?.country?.code &&
      tradeaddress?.address_line_1 &&
      tradeaddress?.postalcode &&
      validNumber(tradeaddress?.postalcode);

    setIsSaveBtn(isIdentical || !isTradeAddressValid);

    // setIsSaveBtn(isIdentical);
  }, [tradeaddress, currentaddress]);

  const initialdata = () => {
    let obj = {
      id: currentaddress?.id,
      country: currentaddress?.country,
      address_line_1: currentaddress?.address_line_1 || "",
      address_line_2: currentaddress?.address_line_2,
      state: currentaddress?.state || "",
      city: currentaddress?.city || "",
      postalcode: currentaddress?.postalcode || "",
    };
    return obj;
  };

  const handleDiscardEdit = () => {
    const obj = initialdata();
    dispatch(
      setLspOnboarding({
        key: "isEdit",
        value: false,
      }),
    );
    setAddress(obj);
  };

  useEffect(() => {
    const obj = initialdata();
    setAddress({ ...obj });
  }, [currentaddress]);

  const handleEnableEdit = () => {
    dispatch(
      setLspOnboarding({
        key: "isEdit",
        value: true,
      }),
    );
  };
  const handleAdressChange = (name, value) => {
    if (name === "country") {
      setAddress((prevState) => ({
        ...prevState,
        [name]: value,
        state: "",
        city: "",
      }));
    }
    setAddress((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    let code = tradeaddress?.country?.code;
    handleStateOption(code);
  }, [tradeaddress?.country]);

  useEffect(() => {
    let code = tradeaddress?.country?.code;
    let scode = tradeaddress?.state?.code;
    handleCitiesOptions(code, scode);
  }, [tradeaddress?.state]);

  const handleStateOption = (countryCode) => {
    if (countryCode) {
      dispatch(fetchStates(countryCode)).then((response) => {
        const options = response.payload.map((state) => ({
          name: state.label,
          code: state.value,
        }));
        dispatch(setLspOnboarding({ key: "statesarray", value: options }));
      });
    }
  };

  const handleCitiesOptions = (countryCode, stateCode) => {
    if (stateCode && countryCode) {
      dispatch(fetchCities([countryCode, stateCode])).then((response) => {
        const cityOptions = response.payload.map((city) => ({
          name: city.label,
          code: city.value,
        }));

        dispatch(setLspOnboarding({ key: "cityarray", value: cityOptions }));
      });
    }
  };

  const handleAddressUpdate = () => {
    setIsUpdating(true);
    dispatch(
      editAddress({
        ...tradeaddress,
        address_line_2: tradeaddress?.address_line_2 || "",
        city: tradeaddress?.city?.code || "",
        state: tradeaddress?.state?.code || "",
        country: tradeaddress?.country?.code || "",
      }),
    ).then(() => {
      dispatch(fetchAddress(tradeaddress?.id));
      setIsUpdating(false);
      initialLoads(lspdetails?.id);
      dispatch(setLspOnboarding({ key: "isEdit", value: false }));
      setSuccessMsg("Address updated");
    });
  };

  return {
    genstate: {
      isEdit,
      tradeaddress,
      isSaveBtn,
      isloading,
      statesarray,
      cityarray,
      isUpdating,
      successmsg,
      isAuditSidebarVisible,
    },
    handleAdressChange,
    handleDiscardEdit,
    handleEnableEdit,
    handleAddressUpdate,
    setSuccessMsg,
    setAuditSidebarVisible,
  };
};

export default useLspAddressUpdate;
